import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { translate } from '../../modules/helper-functions'
import SearchResultCarousel from './SearchResultCarousel'
import { ratio, getSpaceAreaRange, getPropertyPostTypeSlug } from '../../search-common/helpers'
import { colors, fontFamilies } from '../../search-common/settings'

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  `

const Link = styled.a`
  text-decoration:none;
  cursor: pointer;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`

const Header = styled.header`
  padding: 20px;
  flex-grow: 1;
  position: relative;
`

const StreetAddress = styled.h3`
  font-family: ${fontFamilies.aeonik};
  font-size: 24px;
  font-weight: bold;
  width: 100%;
  color: ${colors.white};
`

const SpaceArea = styled.div`
  font-family: ${fontFamilies.aeonik};
  font-size: 16px;
  color: ${( props ) => props.notAvailable ? colors.red : colors.white};
`

const Location = styled.address`
  font-family: ${fontFamilies.aeonik};
  font-style: normal;
  font-size: 16px;
  color: ${colors.grayTone2};
`

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: ${ratio( 1, 1.2 )}%;
  background: linear-gradient(to right, ${colors.grayTone1} 40%, ${colors.blackTwo} 50%, ${colors.grayTone1} 60%);
  background-size: 400%;
  ${( props ) => !props.imageLoaded && `
    background-color: red !important;
    animation: placeholderAnimation 2s ease infinite;
    @keyframes placeholderAnimation {
      0%{background-position:0% 50%}
      50%{background-position:100% 50%}
      100%{background-position:0% 50%}
    }
  `}
`

const BuildingName = styled.span`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${colors.blackTwo};
  font-family: ${fontFamilies.aeonik};
  font-size: 13px;
  font-weight: bold;
  color: ${colors.white};
  padding: 6px 12px;
  text-transform: uppercase;
  z-index: 1;
  text-align: center;
`

/**
 * SearchResult component.
 */
const SearchResult = ({ result, images, locale, notAvailable, translations }) => {
  const [ imageLoaded, setImageLoaded ] = useState( false )

  return (
    <Container>
      <Header>
        <StreetAddress>{result.address}</StreetAddress>
        <SpaceArea notAvailable={notAvailable} >{notAvailable ? translate( translations, 'No available spaces' ) : getSpaceAreaRange( result.spaces )}</SpaceArea>
        <Location>{result.neighborhood},<br />{result.zip_code} {result.city}</Location>
      </Header>
      <ImageContainer imageLoaded={imageLoaded}>
        <SearchResultCarousel width={100} height={120} images={images} setImageLoaded={setImageLoaded}/>
      </ImageContainer>
      {result.name
        ? <BuildingName>{result.name}</BuildingName>
        : null
      }
      <Link href={`/${getPropertyPostTypeSlug( locale )}/${result.slug2}`} />
    </Container>
  )
}

SearchResult.propTypes = {
  result: PropTypes.object.isRequired,
  images: PropTypes.array.isRequired,
  locale: PropTypes.string.isRequired,
  notAvailable: PropTypes.bool,
  translations: PropTypes.object.isRequired,
}

export default SearchResult
